import React, { Component, Fragment } from 'react';
import { Button, Card, Col, Form, Input, Row } from 'antd';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PageListComponent, HeaderListComponent } from "../../../common/component/Index";
import TranslateButton from '../../../common/component/TranslateButton';
import * as Func from '../../../../../helpers/functions';
import { FEATURE_FLAGS, PATHS, UPLOAD_DIRECTORY } from "../../../../../constants/Define";
import DEFINE from "../../../../../constants/Define";
import { getMenuDetail, updateMenu, translateMenu, deleteMenuTranslate } from '../../../../../actions/fnbAction';
import { uploadAction } from '../../../../../actions/uploadAction';
import UploadImage from '../../../common/component/UploadImage';

const FormItem = Form.Item;
let permisionActions = {};

const emptyMenu = {
    id: null,
    code: '',
    name: '',
    outlets: [],
    outletId: '',
    outlet: '',
    imageUrls: [],
    languageCode: 'vi-VN',
    translations: [],
};

class MenuDetail extends Component {
    state = {
        menu: emptyMenu,
    };

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.FNB_MENU);
        const { match } = this.props;
        const id = match?.params?.id;
        if (id) {
            this.props.actions.getMenuDetail(id);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.menuDetail !== this.props.menuDetail && this.props.menuDetail) {
            const menu = this.normalizeMenuDetail(this.props.menuDetail);
            this.setState({ menu });
        }

        if (prevProps.uploadState !== this.props.uploadState && this.props.uploadState.file) {
            const fileUrl = this.props.uploadState.file.data?.fileUrl;
            if (fileUrl) {
                this.setState((prevState) => ({
                    menu: {
                        ...prevState.menu,
                        imageUrls: [fileUrl],
                    },
                }));
            }
        }

        if (!prevProps.menuUpdateSuccess && this.props.menuUpdateSuccess) {
            this.props.history.goBack();
        }
    }

    handleChangeName = (event) => {
        const name = event.target.value;
        this.setState((prevState) => ({
            menu: {
                ...prevState.menu,
                name,
            },
        }));
    };

    getDefaultLanguageCode = () => {
        const { menu } = this.state;
        const defaultLang = (menu.translations || []).find((item) => item.isDefault);
        return (defaultLang && defaultLang.languageCode) || menu.languageCode || 'vi-VN';
    };

    normalizeMenuDetail = (menuDetail) => {
        const translations = menuDetail.translations || [];
        const defaultLang = translations.find((item) => item.isDefault);
        const languageCode = (defaultLang && defaultLang.languageCode) || menuDetail.languageCode || 'vi-VN';
        const name = this.getTranslationName(translations, languageCode) || menuDetail.name || '';
        const imageUrls = (menuDetail.imageUrls || []).filter((item) => item);
        return {
            ...menuDetail,
            translations,
            languageCode,
            name,
            imageUrls,
            outlets: Array.isArray(menuDetail.outlets) ? menuDetail.outlets : [],
        };
    };

    getTranslationName = (translations, languageCode) => {
        const translation = (translations || []).find((item) => item.languageCode === languageCode);
        return translation ? translation.name : '';
    };

    buildUpdatePayload = (menu) => ({
        id: menu.id,
        code: menu.code,
        level: menu.level,
        parentId: menu.parentId,
        status: menu.status,
        type: menu.type,
        outlets: Array.isArray(menu.outlets) ? menu.outlets : [],
        imageUrls: menu.imageUrls,
        isActive: menu.isActive,
        translations: (menu.translations || []).map((item) => ({
            id: item.id,
            fnbMenuId: item.fnbMenuId || menu.id,
            name:
                item.languageCode === this.getDefaultLanguageCode()
                    ? (menu.name || item.name || '')
                    : (item.name || ''),
            description: item.description || '',
            languageCode: item.languageCode,
            isDefault: Boolean(item.isDefault),
        })),
        createdDate: menu.createdDate,
    });

    uploadFile = (event) => {
        const file = event.target.files && event.target.files[0];
        if (!file) return;
        this.props.onUploadFile({
            file,
            directory: UPLOAD_DIRECTORY.IMAGES,
            isFile: 1,
            fieldName: 'menuImage',
        });
    };

    removeImage = () => {
        this.setState((prevState) => ({
            menu: {
                ...prevState.menu,
                imageUrls: [],
            },
        }));
    };

    formatImageUrl = (url) => {
        if (!url) return '';
        return url.startsWith('http') ? url : `https://${url}`;
    };

    formatOutlets = (outlets, menu) => {
        const outletList = Array.isArray(outlets) ? outlets : [];
        const names = outletList
            .map((outlet) => outlet?.name || outlet?.code || outlet?.id)
            .filter(Boolean);
        if (names.length) {
            return names.join(', ');
        }
        return menu?.fnbOutletId || menu?.outletId || menu?.outlet || '';
    };

    handleShowTranslate = (language) => {
        if (!language || !language.code) return;
        this.setState((prevState) => ({
            menu: {
                ...prevState.menu,
                languageCode: language.code,
                name: this.getTranslationName(prevState.menu.translations, language.code),
            },
        }));
    };

    handleExitTranslate = () => {
        this.setState((prevState) => ({
            menu: {
                ...prevState.menu,
                languageCode: this.getDefaultLanguageCode(),
                name: this.getTranslationName(
                    prevState.menu.translations,
                    this.getDefaultLanguageCode()
                ),
            },
        }));
    };

    handleRemoveTranslate = (language) => {
        if (!language || !language.code) return;
        const translation = (this.state.menu.translations || []).find(
            (item) => item.languageCode === language.code
        );
        if (translation && translation.id) {
            this.props.actions.deleteMenuTranslate({
                translateId: translation.id,
                menuId: this.state.menu.id,
                languageCode: language.code,
                languageName: this.props.t(`translate.languages.${language.id}`),
            });
            return;
        }
        this.setState((prevState) => {
            const translations = (prevState.menu.translations || []).filter(
                (item) => item.languageCode !== language.code
            );
            const defaultLanguageCode = this.getDefaultLanguageCode();
            const nextLanguageCode =
                prevState.menu.languageCode === language.code
                    ? defaultLanguageCode
                    : prevState.menu.languageCode;
            return {
                menu: {
                    ...prevState.menu,
                    translations,
                    languageCode: nextLanguageCode,
                    name: this.getTranslationName(translations, nextLanguageCode),
                },
            };
        });
    };

    handleSubmit = (event) => {
        event.preventDefault();
        const { menu } = this.state;
        const { match } = this.props;
        const id = match?.params?.id || menu.id;
        if (!id) return;
        const defaultLanguageCode = this.getDefaultLanguageCode();
        if (menu.languageCode && menu.languageCode !== 'vi-VN' && menu.languageCode !== defaultLanguageCode) {
            const translation = (menu.translations || []).find(
                (item) => item.languageCode === menu.languageCode
            );
            this.props.actions.translateMenu({
                id: translation?.id,
                fnbMenuId: translation?.id ? undefined : id,
                menuId: id,
                name: menu.name || '',
                description: '',
                languageCode: menu.languageCode,
                languageName: this.props.t(`translate.languages.${menu.languageCode.split('-')[0]}`),
            });
            return;
        }
        const updatePayload = this.buildUpdatePayload(menu);
        this.props.actions.updateMenu({
            id,
            updatePayload,
        });
    };

    render() {
        const { t, match, history } = this.props;
        const { menu } = this.state;

        return (
            <Fragment>
                <PageListComponent>
                    <HeaderListComponent
                        path={match.path}
                        titleHeader={Func.capitalizeFirstLetter(
                            (`${t('action.update')} ${t('navigation.menu')}`).toLowerCase()
                        )}
                        extraBreadcrumbs={[
                            { title: t('navigation.menu'), path: PATHS.FNB.MENU_MANAGER.LIST.path },
                            { title: t('action.update') + ' ' + t('navigation.menu').toLowerCase() },
                        ]}
                        componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE && (
                            <TranslateButton
                                languages={menu.translations || []}
                                current={menu.languageCode}
                                onChange={this.handleShowTranslate}
                                onClear={this.handleExitTranslate}
                                onRemove={this.handleRemoveTranslate}
                            />
                        )}
                    />
                    <Card bordered={false}>
                        <Form layout="vertical" onSubmit={this.handleSubmit}>
                            <Row gutter={24}>
                                <Col span={12}>
                                    <FormItem label={t('item.fnb.menu.name')}>
                                        <Input value={menu.name} onChange={this.handleChangeName} />
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    <FormItem label={t('item.fnb.menu.code')}>
                                        <Input value={menu.code} disabled />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={24}>
                                    <FormItem label={t('item.fnb.menu.outlet')}>
                                        <Input value={this.formatOutlets(menu.outlets, menu)} disabled />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={24}>
                                    <FormItem label={t('item.fnb.menu.image')}>
                                        <UploadImage
                                            multiple={false}
                                            loading={this.props.uploadState.isFetching && this.props.uploadState.fieldName === 'menuImage'}
                                            uploadText={t('item.tour.uploadFile')}
                                            loadingText={t('item.tour.uploading')}
                                            onChange={this.uploadFile}
                                            onRemoveThumbnail={this.removeImage}
                                            thumbnails={
                                                menu.imageUrls && menu.imageUrls.length
                                                    ? [this.formatImageUrl(menu.imageUrls[0])]
                                                    : undefined
                                            }
                                        />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} style={{ textAlign: "right", marginTop: 10 }}>
                                    <Button style={{ marginRight: 8 }} onClick={() => history.goBack()}>
                                        {t('action.back')}
                                    </Button>
                                    <Button 
                                        type="primary" 
                                        htmlType="submit" 
                                        loading={this.props.menuUpdateLoading || this.props.menuTranslateLoading}
                                        disabled={!permisionActions || !permisionActions.allowUpdate}
                                    >
                                        {t('action.update')}
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </PageListComponent>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    menuDetail: state.fnbReducer.menuDetail,
    menuUpdateLoading: state.fnbReducer.menuUpdateLoading,
    menuUpdateSuccess: state.fnbReducer.menuUpdateSuccess,
    menuTranslateLoading: state.fnbReducer.menuTranslateLoading,
    uploadState: state.uploadReducer,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            getMenuDetail,
            updateMenu,
            translateMenu,
            deleteMenuTranslate,
        },
        dispatch
    ),
    onUploadFile: (filters) => dispatch(uploadAction(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MenuDetail));
